module.exports = "/images/b093a943b6607e1b7c1a63ec1ca0156a.png";